import {
  vInt,
  vISODate,
  vMilitaryTime,
  vMinValue,
  vNumber,
  vObject,
  vOptional,
  type vOutput,
  vPipe,
  vString,
} from '../validation/index.ts'

export const updateCurrentStopSchema = vObject({
  eventDate: vOptional(vPipe(vString(), vISODate())),
  eventTime: vOptional(vMilitaryTime()),
  message: vOptional(vString()),
  sequence: vPipe(vNumber(), vInt(), vMinValue(-1)),
})
export type UpdateCurrentStopDto = vOutput<typeof updateCurrentStopSchema>
